/**
 * @generated SignedSource<<17b0502ec9d775cc65a1eab4a84210aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type videoShortCarouselPlayerModal$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"videoShortCarouselPlayerContent">;
  };
  readonly " $fragmentType": "videoShortCarouselPlayerModal";
}>;
export type videoShortCarouselPlayerModal$key = ReadonlyArray<{
  readonly " $data"?: videoShortCarouselPlayerModal$data;
  readonly " $fragmentSpreads": FragmentRefs<"videoShortCarouselPlayerModal">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "videoShortCarouselPlayerModal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "type": "Video",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "videoShortCarouselPlayerContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "4e36bef8cd8ccecf1af37417170c047c";

export default node;
